import { Session } from "./session.model";

export class SessionGroup {
  groupId: number;
  sessions: Session[];

  constructor(groupId: number, sessions: Session[]) {
    this.groupId = groupId;
    this.sessions = sessions
  }
}